import { Box } from '@mui/material';
import React from 'react';
import NotificationHeader from './NotificationHeader';
import { Notification } from '../types';

interface NotificationItemProps {
  notification: Notification;
  handleStatus: any
}

const notificationItemStyles = {
  p: 3,
  border: '1px solid',
  borderColor: 'divider',
  position: 'relative',
  borderRadius: 2,
  marginBottom: 2,
  overflowX: 'auto',
  '&:last-child': {
    borderBottom: 'none',
  },
  '&:hover': {
    bgcolor: 'action.selected',
  },
  transition: 'background-color 0.2s ease',
};

const getNotificationBgColor = (read: string) => ({
  bgcolor: read === 'read' ? 'background.paper' : '#e9f2ff',

});

const contentContainerStyles = {
  ml: 7,
};

const NotificationItem: React.FC<NotificationItemProps> = ({ notification, handleStatus }) => {
  return (
    <Box
      sx={{
        ...notificationItemStyles,
        ...getNotificationBgColor(notification.status),
      }}
    >
      <NotificationHeader handleStatus={handleStatus} notification={notification} />
      
      <Box sx={contentContainerStyles}>
        {/* <NotificationContent notification={notification} /> */}
        {/* <NotificationMedia notification={notification} /> */}
      </Box>
    </Box>
  );
};

export default NotificationItem;
